import React, { useState } from 'react';
import Tab from 'react-bootstrap/Tab';
import MockServiceTransactionShuttle from '../../MockServiceTransactionShuttle';
import { Col, FormGroup, Tabs } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { updateHttpRunnerTab } from '../../../../../../store/mockServices/mockServiceDetail/mockServiceDetailActions';
import { MockService } from '../../../../../../types/rest/mockServiceTypes';
import { ApplicationState } from '../../../../../../store/rootReducer';
import MockParameterHandlerWrapper from '../../Params/MockParameterHandlerWrapper';
import { isTemplate } from '../../../../../../utils/miscUtil';
import TemplatesTransactionShuttle from '../../../MockTemplates/TemplatesTransactionShuttle';
import { updateTemplateHttpRunnerTab } from '../../../../../../store/mockServiceTemplates/mockServiceTemplateDetail/mockServiceTemplateDetailActions';
import _ from 'lodash';
import HttpRecordingConfig from '../Messaging/Recordings/HttpRecordingConfig';
import { MockParameterState } from '../../MockParameters';
import { mockServicePatchAction } from '../../../../../../store/mockServices/mockServiceList/mockServiceListActions';
import { updateMockServiceTemplate } from '../../../../../../store/mockServiceTemplates/mockServiceTemplatesActions';

interface Props {
  mockService: MockService;
  disabled: boolean;
}

export const runnerContentTabStyles = 'bg-light p-4 mt-0';

const HttpRunnerTabs = ({ mockService, disabled }: Props) => {
  const { t } = useTranslation('mockServices');

  const activeTab = useSelector((state: ApplicationState) => {
    if (mockService.isHttpRecorderModeActive === true) {
      return 'recording';
    }
    if (isTemplate(mockService)) {
      return state.mockServiceTemplateDetail.httpRunnerTab;
    } else {
      return state.mockServiceDetails.httpRunnerTab;
    }
  });
  const dispatch = useDispatch();

  const updateParameters = (params: MockParameterState) => {
    const ms = Object.assign({}, mockService, params);
    if (!isTemplate(mockService)) {
      dispatch(mockServicePatchAction(ms));
    } else {
      dispatch(updateMockServiceTemplate(ms));
    }
  };

  return (
    <div>
      {mockService.isHttpRecorderModeActive !== true && (
        <Tabs
          transition={false}
          id="http-runner-tabs"
          activeKey={activeTab}
          onSelect={tab => {
            if (isTemplate(mockService)) {
              dispatch(updateTemplateHttpRunnerTab(tab));
            } else {
              dispatch(updateHttpRunnerTab(tab));
            }
          }}
          className={'mb-0'}
        >
          <Tab
            key={'main'}
            className={runnerContentTabStyles}
            eventKey="main"
            title={t('mockServiceDetails.transactions')}
          >
            {isTemplate(mockService) ? (
              <TemplatesTransactionShuttle disabled={false} template={mockService} transactionType={'HTTP'} />
            ) : (
              <MockServiceTransactionShuttle mockService={mockService} disabled={disabled} transactionType={'HTTP'} />
            )}
          </Tab>
          <Tab
            key={'parameters'}
            unmountOnExit={true}
            mountOnEnter={true}
            eventKey="parameters"
            className={runnerContentTabStyles}
            title={t('mockServiceDetails.parameters')}
          >
            <MockParameterHandlerWrapper mockService={mockService} disabled={disabled} />
          </Tab>
        </Tabs>
      )}
      {mockService.isHttpRecorderModeActive === true && (
        <HttpRecordingConfig onUpdate={updateParameters} mockService={mockService} disabled={disabled} />
      )}
    </div>
  );
};

export default HttpRunnerTabs;
